import { Component, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { combineLatest, switchMap, of } from 'rxjs'
import {
  EXP_NEW_ATHLETE_PROFILES_ID,
  EXP_NEW_ATHLETE_PROFILES_VARIATION,
  EXP_NEW_COLLECTION_ENTITY_HUBS_ID,
  EXP_NEW_COLLECTION_ENTITY_HUBS_VARIATION
} from '../shared/experimentation/experiment.model'
import { ExperimentationService } from '../shared/experimentation/experimentation.service'

/**
 * Purpose of this component is temporary, until new collection pages are rolled out
 * and no longer hidden behind this experiment feature flag.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *ngIf="shouldShowNewEntityHub$ | async; else oldCollection">
      <!-- To make it possible to share data and ads across parent and child routes,
      we moved all the html to the parent route driven by one reactive stream.
      So this route view will no longer be used with the new entity collection pages. -->
      <span></span>
    </ng-container>
    <ng-template #oldCollection>
      <flo-collection-tab-view></flo-collection-tab-view>
    </ng-template>
  `
})
export class EntityHubContentExperimentComponent {
  constructor(private readonly es: ExperimentationService, private readonly router: Router) {}

  public shouldShowNewEntityHub$ = combineLatest([
    this.es.isInVariation(
      EXP_NEW_ATHLETE_PROFILES_ID,
      EXP_NEW_ATHLETE_PROFILES_VARIATION,
      this.router.url.startsWith('/people/')
    ),
    this.es.isInVariation(
      EXP_NEW_COLLECTION_ENTITY_HUBS_ID,
      EXP_NEW_COLLECTION_ENTITY_HUBS_VARIATION,
      !!this.router.url.match(/^\/collections\/(\d+)/)
    )
  ]).pipe(
    switchMap(([isInAthletesVariation, isInCollectionsVariation]) => {
      return of(
        (isInAthletesVariation && this.router.url.startsWith('/people/')) ||
          (isInCollectionsVariation && !!this.router.url.match(/^\/collections\/(\d+)/))
      )
    })
  )
}
